import {
  openToViewFdbk,
  openToFillFdbk,
  closemarks,
  handleKeyUp,
  myMethod,
  viewRequiredDocs,
  openFinalOnHold,
  openFinalAction,
  closeFinalAction,
  getApproverId,
  closeSelOpshedFinalModal,
  closefillFeedbackmodal,
  rejectConfirmModal,
  clearFeedbckDetails,
  scheduleInterviewModal,
  closeFinalHold,
  sendForOpshead,
} from "../../controllers/JD/helpers.js";
import axios from "axios";

import { getValidations } from "../../controllers/JD/validations.js";
import {
  getopsHead,
  sendForApproval,
  openAssessmentConfigModal,
  createMeeting,
  createmeetingwithVccl,
  openGiveFeedbackModal,
  history,
  directOnHold,
  assignMarksSuccess,
  rescheduled,
  cancelMeet,
} from "../../controllers/JD/asynchronous.js";
import toast from "../../components/mixin/toast";

import { getTeamsToken } from "../../utils/apiFunctions.js";

const jddetailsMixins = {
  name: "jddetailsMixins",
  mixins: [toast],

  validations() {
    return getValidations(this);
  },
  computed: {
    teams() {
      return this.teamsToken !== "";
    },
    newDataeVAS() {
      let year = String(this.ScheduleInterview.date).slice(0, 4);
      let month = String(this.ScheduleInterview.date).slice(5, 7);
      let day = String(this.ScheduleInterview.date).slice(8, 10);
      let hrs = String(this.ScheduleInterview.startTime).slice(0, 2);
      let min = String(this.ScheduleInterview.startTime).slice(3, 5);
      let newMonth = parseInt(month - 1);
      let result = new Date(year, newMonth, day, hrs, min, 0, 0);

      return result;
    },
    newDataeEnd() {
      const year = String(this.ScheduleInterview.date).slice(0, 4);
      const month = String(this.ScheduleInterview.date).slice(5, 7);
      const day = String(this.ScheduleInterview.date).slice(8, 10);
      const hrs = String(this.ScheduleInterview.endTime).slice(0, 2);
      const min = String(this.ScheduleInterview.endTime).slice(3, 5);
      const newMonth = parseInt(month - 1);
      const result = new Date(year, newMonth, day, hrs, min, 0, 0);

      return result;
    },
    isExternalEmpty() {
      return this.ScheduleInterview.externalPanelist.length == 0;
    },
    // CHECK ALL EXTERNAL PANELIST MAIL WHETHER IT BELONGS TO PARTICULAR DOMAIN
    checkExternalMails() {
      for (let i in this.externalPan) {
        let mail = this.externalPan[i].split("@")[1];
        if (this.companyMail(mail)) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    async addPanelist() {
      const response = await getTeamsToken();
      const token = response.data.token;
      axios({
        method: "POST",
        url: `https://graph.microsoft.com/v1.0/users/${this.roleValues.email}/calendar/getschedule`,
        data: JSON.stringify({
          Schedules: [this.ScheduleInterview.panelist.email],
          StartTime: {
            dateTime: this.newDataeVAS,
            timeZone: "UTC",
          },
          EndTime: {
            dateTime: this.newDataeEnd,
            timeZone: "UTC",
          },
          availabilityViewInterval: this.timeDifference(
            this.newDataeEnd,
            this.newDataeVAS
          ),
        }),
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          if (response.data.value[0].availabilityView) {
            this.ScheduleInterview.teamsStatus =
              response.data.value[0].availabilityView;
            if (this.ScheduleInterview.teamsStatus == "0") {
              this.ScheduleInterview.panelistStatus = "Free";
            } else if (this.ScheduleInterview.teamsStatus == "1") {
              this.ScheduleInterview.panelistStatus = "Tentative";
            } else if (this.ScheduleInterview.teamsStatus == "2") {
              this.ScheduleInterview.panelistStatus = "Busy";
            } else if (this.ScheduleInterview.teamsStatus == "3") {
              this.ScheduleInterview.panelistStatus = "Out of office";
            } else if (this.ScheduleInterview.teamsStatus == "4") {
              this.ScheduleInterview.panelistStatus = "Unavailable";
            }
          } else {
            this.ScheduleInterview.panelistStatus = "Out of Organisation";
            this.ScheduleInterview.teamsStatus = "5";
          }
          this.externalPan = [];
          this.errorpanel = false;
        })
        .catch((error) => {
          console.error(error);
          this.ScheduleInterview.panelistStatus = "Status unknown";
          this.ScheduleInterview.teamsStatus = "6";
          this.externalPan = [];
          this.errorpanel = false;
        });
    },
    timeDifference(date1String, date2String) {
      const date1 = new Date(date1String);
      const date2 = new Date(date2String);
      const diffInMs = Math.abs(date2 - date1);
      let hours = Math.floor(diffInMs / 3600000);
      let minutes = Math.floor((diffInMs % 3600000) / 60000);
      hours *= 60;
      minutes += hours;
      return minutes.toString();
    },
    async cancelMeet() {
      await cancelMeet(this);
    },

    getVcclAttendees() {
      let attend = [];

      // ADDING CANDIDATE EMAIL
      if (!this.isExternalEmpty) {
        if (!this.checkExternalMails) {
          attend.push(this.activeCandidate.email);
        }
      } else {
        attend.push(this.activeCandidate.email);
      }
      // ADDING PANELIST EMAIL
      if (this.isExternalEmpty) {
        attend.push(this.ScheduleInterview.panelist.email);
      } else {
        for (const i of this.ScheduleInterview.externalPanelist) {
          attend.push(i);
        }
      }
      return attend;
    },

    getAttendees() {
      let attend = [];

      // ADDING CANDIDATE EMAIL
      if (!this.isExternalEmpty) {
        if (!this.checkExternalMails) {
          attend.push({
            emailAddress: {
              address: this.activeCandidate.email,
            },
            type: "required",
          });
        }
      } else {
        attend.push({
          emailAddress: {
            address: this.activeCandidate.email,
          },
          type: "required",
        });
      }
      // ADDING PANELIST EMAIL
      if (this.isExternalEmpty) {
        attend.push({
          emailAddress: {
            address: this.ScheduleInterview.panelist.email,
          },
          type: "required",
        });
      } else {
        for (const i of this.ScheduleInterview.externalPanelist) {
          attend.push({
            emailAddress: {
              address: i,
            },
            type: "required",
          });
        }
      }
      return attend;
    },
    clearObject() {
      this.clearDetails = false;
    },
    isFinalSelected() {
      return JSON.parse(this.finalSelectedCandidate.select);
    },
    hideAttendees() {
      return JSON.parse(!this.checkExternalMails);
    },
    openToViewFdbk() {
      openToViewFdbk(this);
    },
    openToFillFdbk() {
      openToFillFdbk(this);
    },
    closemarks(index) {
      closemarks(this, index);
    },
    handleKeyUp() {
      handleKeyUp(this);
    },
    myMethod(data) {
      myMethod(this, data);
    },
    viewRequiredDocs(candidateID) {
      viewRequiredDocs(this, candidateID);
    },
    openFinalOnHold(candidate) {
      openFinalOnHold(this, candidate);
    },
    // OPEN MODAL FOR POSTING ON-HOLD ACTION FOR SELECTED CANDIDATES
    openFinalAction(candidate) {
      openFinalAction(this, candidate);
    },
    // CLOSE MODAL FOR POSTING ON-HOLD ACTION FOR SELECTED CANDIDATES
    closeFinalAction() {
      closeFinalAction(this);
    },
    getApproverId() {
      getApproverId(this);
    },
    closeSelOpshedFinalModal() {
      closeSelOpshedFinalModal(this);
    },
    closefillFeedbackmodal() {
      closefillFeedbackmodal(this);
    },
    rejectConfirmModal(data) {
      rejectConfirmModal(this, data);
    },
    clearFeedbckDetails() {
      clearFeedbckDetails(this);
    },
    scheduleInterviewModal(Details) {
      scheduleInterviewModal(this, Details);
    },
    closeFinalHold() {
      closeFinalHold(this);
    },
    sendForOpshead() {
      sendForOpshead(this);
    },
    // GET LIST OF OPSHEAD FOR FINAL APPROVAL VIA KANBAN
    async getOpsHead() {
      await getopsHead(this);
    },
    async sendForApproval() {
      await sendForApproval(this);
    },
    async openAssessmentConfigModal(Details) {
      await openAssessmentConfigModal(this, Details);
    },
    async createMeeting() {
      await createMeeting(this);
    },
    async createmeetingwithVccl() {
      await createmeetingwithVccl(this);
    },
    async openGiveFeedbackModal(data) {
      this.select_opsHeadName = "";
      this.opsHeadRemarks = "";
      this.$v.$reset();

      await openGiveFeedbackModal(this, data);
    },
    async history(data) {
      await history(this, data);
    },
    async directOnHold() {
      await directOnHold(this);
    },
    async reschedule(data) {
      await rescheduled(data, this);
    },
    async assignMarksSuccess(data) {
      await assignMarksSuccess(this, data);
    },
  },
};
export default jddetailsMixins;
